import { useMemo } from "react";

import type { HostHubInstantBookListing } from "../types/model/instant-book-listing";
import { toInstantBookListings } from "../utils/host-hub-instant-book.utils";

import useHostHubOwnerListings from "./useHostHubOwnerListings";

type UseHostHubInstantBookListingsResult = {
  isError: boolean;
  isLoading: boolean;
  listings: HostHubInstantBookListing[];
};

/**
 * Fetches the host's owned listings and derives the Instant-Book-eligible
 * ones (capped) for the "Enable Instant Book" recommendation.
 */
const useHostHubInstantBookListings =
  (): UseHostHubInstantBookListingsResult => {
    const ownerListings = useHostHubOwnerListings();
    const listings = useMemo(
      () => toInstantBookListings(ownerListings.listings),
      [ownerListings.listings],
    );

    return {
      isError: ownerListings.isError,
      isLoading: ownerListings.isLoading,
      listings,
    };
  };

export default useHostHubInstantBookListings;
